"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageStructureDto = /** @class */ (function () {
    /**
     * PageDto structure constructor
     * @param layout
     */
    function PageStructureDto(layout) {
        this._layout = layout || '';
    }
    /**
     * Get pageStructure layout
     */
    PageStructureDto.prototype.getLayout = function () {
        return this._layout;
    };
    PageStructureDto.prototype.toJson = function () {
        return JSON.stringify({
            layout: this._layout
        });
    };
    return PageStructureDto;
}());
exports.PageStructureDto = PageStructureDto;
//# sourceMappingURL=page-structure.js.map